import { combineReducers } from 'redux';
import {
  experimentAnalyticsBasePageReducer,
  experimentAnalyticsMetricsReducer,
  experimentAnalyticsOverviewTabReducer,
  experimentAnalyticsPerformanceTabReducer,
  experimentAnalyticsTranslationReducer,
} from './analyticsPage';

export const experimentAnalyticsPageReducer = combineReducers({
  basePage: experimentAnalyticsBasePageReducer,
  overviewTab: experimentAnalyticsOverviewTabReducer,
  performanceTab: experimentAnalyticsPerformanceTabReducer,
  metrics: experimentAnalyticsMetricsReducer,
  i18n: experimentAnalyticsTranslationReducer,
});
